import { getAccessToken, accessTokenInterceptor } from '@teko/auth';
import Api, { ApiError } from '@teko/api';
import i18next from 'i18next';

var viLang = {
	"Mã giảm giá này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để áp dụng mã giảm giá?": "Mã giảm giá này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để áp dụng mã giảm giá?",
	"Khuyến mãi này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để nhận khuyến mại này?": "Khuyến mãi này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để nhận khuyến mại này?",
	"Khuyến mãi tặng voucher đã hết ngân sách": "Khuyến mãi tặng voucher đã hết ngân sách",
	"Giỏ hàng có khuyến mãi hết ngân sách": "Giỏ hàng có khuyến mãi hết ngân sách",
	"Mã giảm giá đã được sử dụng hoặc quá số lần sử dụng": "Mã giảm giá đã được sử dụng hoặc quá số lần sử dụng",
	"Giỏ hàng có sản phẩm đã được cập nhật lại giá": "Giỏ hàng có sản phẩm đã được cập nhật lại giá",
	"Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép": "Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép",
	"Giỏ hàng chứa khuyến mãi đã bị vô hiệu": "Giỏ hàng chứa khuyến mãi đã bị vô hiệu",
	"Giỏ hàng chứa sản phẩm không được phép áp dụng khuyến mãi": "Giỏ hàng chứa sản phẩm không được phép áp dụng khuyến mãi",
	"Bạn không đủ điều kiện để hưởng khuyến mãi": "Bạn không đủ điều kiện để hưởng khuyến mãi",
	"Mã giảm giá quá hạn sử dụng": "Mã giảm giá quá hạn sử dụng",
	"Giỏ hàng chứa flash sale đã bị vô hiệu": "Giỏ hàng chứa flash sale đã bị vô hiệu",
	"Giỏ hàng chứa flash sale đã hết số lượng khuyến mãi": "Giỏ hàng chứa flash sale đã hết số lượng khuyến mãi",
	"Đơn hàng chứa sản phẩm đã hết tồn nên không thể tiếp tục thanh toán.": "Đơn hàng chứa sản phẩm đã hết tồn nên không thể tiếp tục thanh toán.",
	"Không thể giữ tồn do đơn hàng đã được giữ tồn thành công trước đó": "Không thể giữ tồn do đơn hàng đã được giữ tồn thành công trước đó",
	"Đơn hàng đã thanh toán thành công nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!": "Đơn hàng đã thanh toán thành công nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!",
	"Đơn hàng đã bị hủy trước đó nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!": "Đơn hàng đã bị hủy trước đó nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!",
	"Mã đã được sử dụng hoặc quá số lần sử dụng": "Mã đã được sử dụng hoặc quá số lần sử dụng",
	"Số lượt sử dụng mã giảm giá đã hết": "Số lượt sử dụng mã giảm giá đã hết",
	"Mã không hợp lệ": "Mã không hợp lệ",
	"Giá trị đơn hàng không thỏa mãn điều kiện áp dụng mã": "Giá trị đơn hàng không thỏa mãn điều kiện áp dụng mã",
	"Sản phẩm trong giỏ hàng không được áp dụng mã": "Sản phẩm trong giỏ hàng không được áp dụng mã",
	"Mã giảm giá không áp dụng cho tài khoản của bạn": "Mã giảm giá không áp dụng cho tài khoản của bạn",
	"Ngân sách sử dụng mã đã hết": "Ngân sách sử dụng mã đã hết",
	"Vui lòng đăng nhập để sử dụng mã": "Vui lòng đăng nhập để sử dụng mã",
	"Số tiền giảm của mã giảm giá đang lớn hơn giá trị đơn hàng của bạn": "Số tiền giảm của mã giảm giá đang lớn hơn giá trị đơn hàng của bạn",
	"Mã giảm giá không hợp lệ, vui lòng thử lại": "Mã giảm giá không hợp lệ, vui lòng thử lại",
	"Mã giảm giá không tồn tại hoặc đã bị vô hiệu": "Mã giảm giá không tồn tại hoặc đã bị vô hiệu",
	"Vui lòng chọn thời gian nhận hàng lớn hơn thời gian hiện tại!": "Vui lòng chọn thời gian nhận hàng lớn hơn thời gian hiện tại!",
	"Không thể áp dụng thêm Mã giảm giá/Phiếu mua hàng": "Không thể áp dụng thêm Mã giảm giá/Phiếu mua hàng"
};

var enLang = {
	"Mã giảm giá này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để áp dụng mã giảm giá?": "This discound code can not apply together with combo promotion in the Cart. Do you want to remove the combo and apply this discount code?",
	"Khuyến mãi này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để nhận khuyến mại này?": "This promotion can not apply together with combo promotion in the Cart. Do you want to remove the combo and apply this promotion?",
	"Khuyến mãi tặng voucher đã hết ngân sách": "The e-voucher promotion has run out of budget",
	"Giỏ hàng có khuyến mãi hết ngân sách": "There is a promotion in the Cart has run out of budget",
	"Mã giảm giá đã được sử dụng hoặc quá số lần sử dụng": "The discount code has exceeded the number of uses",
	"Giỏ hàng có sản phẩm đã được cập nhật lại giá": "There is a price change of the products in the Cart",
	"Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép": "The discount code has exceeded the number of uses",
	"Giỏ hàng chứa khuyến mãi đã bị vô hiệu": "There is an inactive promotion in the Cart",
	"Giỏ hàng chứa sản phẩm không được phép áp dụng khuyến mãi": "There are products is not allowed to apply promotion in the Cart",
	"Bạn không đủ điều kiện để hưởng khuyến mãi": "You are not eligible to receive the promotions",
	"Mã giảm giá quá hạn sử dụng": "The discount code has been expired",
	"Giỏ hàng chứa flash sale đã bị vô hiệu": "There is an inactive flash sale in the Cart",
	"Giỏ hàng chứa flash sale đã hết số lượng khuyến mãi": "There is out-of-stock flash sale in the Cart",
	"Đơn hàng chứa sản phẩm đã hết tồn nên không thể tiếp tục thanh toán.": "Can not continue making payment for the current order because it contains out-of-stock product.",
	"Không thể giữ tồn do đơn hàng đã được giữ tồn thành công trước đó": "Can not hold inventory because the order has held inventory successfully.",
	"Đơn hàng đã thanh toán thành công nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!": "Can not update the order because it has been paid successfully!",
	"Đơn hàng đã bị hủy trước đó nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!": "Can not update the order because it has been cancelled successfully!",
	"Mã đã được sử dụng hoặc quá số lần sử dụng": "The discount code has been used or exceed the number of uses",
	"Số lượt sử dụng mã giảm giá đã hết": "The discount code has exceeded the number of uses",
	"Mã không hợp lệ": "Invalid code",
	"Giá trị đơn hàng không thỏa mãn điều kiện áp dụng mã": "The total mount of the order is not eligible to apply discount code",
	"Sản phẩm trong giỏ hàng không được áp dụng mã": "The discount code is not applicable for the products in the Cart",
	"Mã giảm giá không áp dụng cho tài khoản của bạn": "The discount code is not applicable for your account",
	"Ngân sách sử dụng mã đã hết": "The discount code has run out of budget",
	"Vui lòng đăng nhập để sử dụng mã": "Please login to use the discount code",
	"Số tiền giảm của mã giảm giá đang lớn hơn giá trị đơn hàng của bạn": "The discount amount is greater than the total amount of the order",
	"Mã giảm giá không hợp lệ, vui lòng thử lại": "The discount code is invalid, please try again",
	"Mã giảm giá không tồn tại hoặc đã bị vô hiệu": "The discount code is not existed or has been inactive",
	"Vui lòng chọn thời gian nhận hàng lớn hơn thời gian hiện tại!": "Please choose a larger delivery time than the current one!",
	"Không thể áp dụng thêm Mã giảm giá/Phiếu mua hàng": "Can not apply more coupons/e-Vouchers"
};

const NAMESPACE = 'cart';
const t = (keys, options) => {
    return i18next.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
};
const lang = {
    vi: viLang,
    en: enLang,
};

const ErrorMessageMapping = new Map([
    [400400, 'Khuyến mãi tặng voucher đã hết ngân sách'],
    [400401, 'Giỏ hàng có khuyến mãi hết ngân sách'],
    [400402, 'Mã giảm giá đã được sử dụng hoặc quá số lần sử dụng'],
    [400403, 'Giỏ hàng có sản phẩm đã được cập nhật lại giá'],
    [400404, 'Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép'],
    [400405, 'Giỏ hàng chứa khuyến mãi đã bị vô hiệu'],
    [400406, 'Giỏ hàng chứa sản phẩm không được phép áp dụng khuyến mãi'],
    [400407, 'Bạn không đủ điều kiện để hưởng khuyến mãi'],
    [400408, 'Mã giảm giá quá hạn sử dụng'],
    [400409, 'Giỏ hàng chứa flash sale đã bị vô hiệu'],
    [400410, 'Giỏ hàng chứa flash sale đã hết số lượng khuyến mãi'],
    [400411, 'Giỏ hàng chứa một số sản phẩm hết hàng hoặc không đủ số lượng'],
    [400412, 'Không thể giữ tồn do đơn hàng đã được giữ tồn thành công trước đó'],
    [
        400413,
        'Đơn hàng đã thanh toán thành công nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!',
    ],
    [
        400414,
        'Đơn hàng đã bị hủy trước đó nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!',
    ],
    [400501, 'Mã đã được sử dụng hoặc quá số lần sử dụng'],
    [400502, 'Số lượt sử dụng mã giảm giá đã hết'],
    [400503, 'Mã không hợp lệ'],
    [400504, 'Giá trị đơn hàng không thỏa mãn điều kiện áp dụng mã'],
    [400505, 'Sản phẩm trong giỏ hàng không được áp dụng mã'],
    [400506, 'Mã giảm giá không áp dụng cho tài khoản của bạn'],
    [400507, 'Mã không hợp lệ'],
    [400508, 'Ngân sách sử dụng mã đã hết'],
    [400509, 'Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép'],
    [400510, 'Vui lòng đăng nhập để sử dụng mã'],
    [
        400511,
        'Số tiền giảm của mã giảm giá đang lớn hơn giá trị đơn hàng của bạn',
    ],
    [400512, 'Mã giảm giá không hợp lệ, vui lòng thử lại'],
    [400513, 'Mã giảm giá không tồn tại hoặc đã bị vô hiệu'],
    [
        400204,
        'Mã giảm giá này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để áp dụng mã giảm giá?',
    ],
    [
        400205,
        'Khuyến mãi này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để nhận khuyến mại này?',
    ],
    [400201, 'Không thể áp dụng thêm Mã giảm giá/Phiếu mua hàng'],
    [400922, 'Vui lòng chọn thời gian nhận hàng lớn hơn thời gian hiện tại!'],
]);
const getError = (resp) => {
    const tKey = ErrorMessageMapping.get(resp.statusCode);
    if (!tKey)
        return new ApiError(resp.message || resp.error, resp.statusCode, resp);
    const message = t(tKey);
    return new ApiError(message, resp.statusCode, resp);
};

const LS_CART_TOKEN = 'cart_token';
const cartTokenHeader = 'x-cart-token';
const getCartToken = (localStorageKey) => localStorage.getItem(localStorageKey);
const setCartToken = (token, localStorageKey = LS_CART_TOKEN) => localStorage.setItem(localStorageKey, token);
const defaultCartValue = {
    id: '',
    grandTotal: 0,
    orderCoupons: {
        applicableCoupons: [],
        inapplicableCoupons: [],
    },
    orderLines: [],
    promotions: [],
    shippingFee: 0,
    subTotal: 0,
    totalDiscount: 0,
    eVouchers: [],
};
const parseJWT = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64)
            .split('')
            .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
        return JSON.parse(jsonPayload)['cid'];
    }
    catch (_a) {
        return null;
    }
};
class CartService {
    constructor(cartApiUrl, localStorageKey = LS_CART_TOKEN, language) {
        this.getCart = async (params) => {
            const cartToken = getCartToken(this.localStorageKey);
            const accessToken = getAccessToken();
            return !cartToken && !accessToken
                ? Promise.resolve(defaultCartValue)
                : this.cartApi
                    .get('/api/v1/cart', { params })
                    .then(({ data }) => data.result);
        };
        this.addToCart = async (params, body) => {
            const { data, headers } = await this.cartApi.post('api/v1/cart/add-to-cart', body, { params });
            const token = headers[cartTokenHeader];
            if (token && token !== 'undefined') {
                localStorage.setItem(this.localStorageKey, token);
            }
            return Object.assign(Object.assign({}, data.result), { cartId: parseJWT(token) });
        };
        this.applyCoupon = async (params, body) => {
            const { data } = await this.cartApi.post('api/v1/cart/apply-coupon', body, {
                params,
            });
            return data.result;
        };
        this.removeCoupon = (params, body) => {
            return this.cartApi.delete('api/v1/cart/clear-coupon', body, { params });
        };
        this.clearCart = (params) => {
            return this.cartApi.delete('api/v1/cart', null, { params });
        };
        this.updateOrderLine = async (params, id, body) => {
            return this.cartApi
                .put(`api/v1/cart/order-lines/${id}`, body, {
                params: Object.assign(Object.assign({}, params), { graceful: true }),
            })
                .then(({ data }) => Promise.resolve(data.result));
        };
        this.updateSellerItems = (params, sellerId, selected) => {
            return this.cartApi.put('api/v1/cart/order-items', { selected }, { params: Object.assign(Object.assign({}, params), { sellerId }) });
        };
        this.removeOrderLine = async (params, id) => {
            return await this.cartApi.delete(`api/v1/cart/order-lines/${id}`, null, {
                params,
            });
        };
        this.setShippingAddress = (params, selectedAddress) => {
            const infoSetShippingAddr = Object.assign(Object.assign({ addressId: selectedAddress.addressId, wardCode: (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.wardCode) || '', districtCode: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.districtCode, provinceCode: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.provinceCode, wardName: (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.wardName) || '', districtName: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.districtName, provinceName: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.provinceName, address: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.address, name: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.name }, ((selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.email) && { email: selectedAddress.email })), { telephone: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.telephone, addressNote: '' });
            return this.cartApi.post(`api/v1/cart/shipping-address`, infoSetShippingAddr, { params });
        };
        this.getPaymentMethod = async (params, orderCode) => {
            const { data } = await this.cartApi.get('api/v1/cart/payment-methods-v2', {
                params: Object.assign(Object.assign({}, params), (orderCode ? { orderCode } : {})),
            });
            return data.result;
        };
        this.checkout = async (params, body) => {
            var _a, _b, _c, _d;
            const { data } = await this.cartApi.post('api/v1/cart/checkout', body, {
                params,
            });
            return Object.assign(Object.assign({}, data.result), { orderId: ((_a = data.result) === null || _a === void 0 ? void 0 : _a.orderIdString) || ((_b = data.result) === null || _b === void 0 ? void 0 : _b.orderId), id: ((_c = data.result) === null || _c === void 0 ? void 0 : _c.orderIdString) || ((_d = data.result) === null || _d === void 0 ? void 0 : _d.orderId), get remainPayment() {
                    return data.result.grandTotal - data.result.totalPaid;
                } });
        };
        this.getOrderByCode = async (params, code) => {
            const { data } = await this.cartApi.get(`/api/v1/orders/${code}`, {
                params,
            });
            const order = data.result;
            return Object.assign(Object.assign({}, order), { orderId: (order === null || order === void 0 ? void 0 : order.orderIdString) || (order === null || order === void 0 ? void 0 : order.id), id: (order === null || order === void 0 ? void 0 : order.orderIdString) || (order === null || order === void 0 ? void 0 : order.id), grandTotal: parseInt(order.grandTotal), get remainPayment() {
                    var _a;
                    const prevPayment = ((_a = order === null || order === void 0 ? void 0 : order.payments) === null || _a === void 0 ? void 0 : _a.reduce((amount, currentPayment) => amount + currentPayment.amount, 0)) || 0;
                    return order.grandTotal - prevPayment;
                } });
        };
        this.getApplicableServices = async (params) => {
            const { data } = await this.cartApi.get('api/v1/cart/applicable-services', {
                params,
            });
            return data.result;
        };
        this.findApplicableServices = async (params, body) => {
            const { data } = await this.cartApi.post('/api/v1/cart/applicable-services', body, { params });
            return data.result;
        };
        this.getDeliveryOptions = async (params, body) => {
            const { data } = await this.cartApi.post('/api/v1/cart/delivery-options', body, { params });
            return data.result;
        };
        this.applyServiceToCart = async (params, body) => {
            const { data } = await this.cartApi.put('/api/v1/cart/apply-service', body, { params });
            return data.result;
        };
        this.applyPaymentMethodToCard = async (params, body) => {
            const { data } = await this.cartApi.put('/api/v1/cart/apply-payment-method', body, { params });
            return data.result;
        };
        this.cartApi = new Api(cartApiUrl, getError);
        this.localStorageKey = localStorageKey;
        this.cartApi.addInterceptor(accessTokenInterceptor);
        this.cartApi.addInterceptor((request) => {
            const cartToken = getCartToken(localStorageKey);
            if (cartToken) {
                request.headers.set(cartTokenHeader, cartToken);
            }
        });
        this.cartApi.addInterceptor((request) => {
            request.headers.set('Accept-Language', language || '*');
        });
    }
}

const TECHNICAL_SUPPORT_SERVICE_ID = 5;
const SHOWROOM_SERVICE_ID = 4;
const DELIVERY_SERVICE_GROUP_ID = 1;
var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["STANDARD"] = "Standard";
    DeliveryMethod["SHOWROOM"] = "Showroom";
})(DeliveryMethod || (DeliveryMethod = {}));
var DeliveryType;
(function (DeliveryType) {
    DeliveryType["DOMESTIC"] = "DELIVERY_TYPE_AT_HOME";
    DeliveryType["SHOWROOM"] = "DELIVERY_TYPE_PICKUP";
})(DeliveryType || (DeliveryType = {}));

const getApplicableCoupons = (cart) => (cart === null || cart === void 0 ? void 0 : cart.orderCoupons.applicableCoupons.filter((coupon) => {
    if (!!(cart === null || cart === void 0 ? void 0 : cart.promotions.find((promotion) => promotion.coupon === coupon.condition.coupon))) {
        return false;
    }
    return !coupon.isPrivate && !coupon.isDefault && !!coupon.benefit.discount;
})) || [];
const getInapplicableCoupons = (cart) => (cart === null || cart === void 0 ? void 0 : cart.orderCoupons.inapplicableCoupons.filter((coupon) => !coupon.isPrivate && !coupon.isDefault && !!coupon.benefit.discount)) || [];

export { CartService, DELIVERY_SERVICE_GROUP_ID, DeliveryMethod, DeliveryType, NAMESPACE, SHOWROOM_SERVICE_ID, TECHNICAL_SUPPORT_SERVICE_ID, defaultCartValue, getApplicableCoupons, getInapplicableCoupons, lang, parseJWT, setCartToken };
